// extracted by mini-css-extract-plugin
module.exports = {"Hr":"ShootDuration_Hr__2VxHq","Table":"ShootDuration_Table__1Ah3L","IconTime":"ShootDuration_IconTime__2hV-x"};